import { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/styles';
import { FilledInput, Button, FormGroup, FormLabel, FormControl, Box, Grid, Collapse, Divider } from '@material-ui/core';

import AuthContext from '../../context';
import { put } from '../../utils/api-services';
import helpers from '../../utils/helpers';

const useStyles = makeStyles(() => ({
    buttonContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: 5
    },
    updateBtn: {
        width: '100%',
        backgroundColor: '#0d6efd',
        borderColor: '#0d6efd',
        '&:hover': {
            backgroundColor: '#0d6efd',
            borderColor: '#0d6efd',
            boxShadow: 'none'
        }
    }
}));

const TicketMasterDetailEdit = ({ open, onClose, id, permissions, master, setMaster }) => {

    const classes = useStyles();
    const { showToast, signOut, showLoader } = useContext(AuthContext);
    const [state, setState] = useState({
        code: master.code,
        date: master.date,
        net_weight_scale: master.net_weight_scale,
        purchase_order: master?.purchase_order ?? ''
    });

    const handleChange = ({ target }) => setState(prev => ({ ...prev, [target.name]: target.value }));

    const validate = () => {
        if (!state.code.trim() && !state.date.trim()) {
            showToast('All fields are required', 'error');
            return false;
        }

        const cond = window.confirm('Are you sure you want to update this master ticket?');
        return cond;
    }

    const update = async () => {
        const cond = validate();
        if (cond) {
            showLoader(true);
            const response = await put(`/ticketMaster/${id}/update`, state);
            if (response.status === 200) {
                const { message, data } = response;
                showToast(message);
                setMaster(data);
                onClose();
                clear();
            } else {
                console.log('[TicketMasterDetailEdit] update error', response);
                helpers.failRequest(response, showToast, signOut);
            }
            showLoader(false);
        }
    }

    const clear = () => setState({ code: master.code, date: master.date, net_weight_scale: master.net_weight_scale, purchase_order: master?.purchase_order ?? '' });

    return (
        <Collapse in={open}>
            <Divider />
            <h3>{'Edit mastert ticket'}</h3>
            <Grid container>
                <Grid item xs={6} md={3} xl={2}>
                    <FormGroup>
                        <FormLabel>{'Code'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                autoComplete='off'
                                type='text'
                                name='code'
                                placeholder='Code'
                                value={state.code}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>

                <Grid item xs={6} md={3}>
                    <FormGroup>
                        <FormLabel>{'Date'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                autoComplete='off'
                                type='date'
                                name='date'
                                placeholder='Date'
                                value={state.date}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>

                {
                    !master.is_automatic &&
                    <Grid item xs={6} md={3} xl={2}>
                        <FormGroup>
                            <FormLabel>{'Net weight scale'}</FormLabel>
                            <FormControl
                                variant='filled'
                                component={Box}
                                width='100%'
                            >
                                <FilledInput
                                    autoComplete='off'
                                    type='number'
                                    inputProps={{ min: 0 }}
                                    name='net_weight_scale'
                                    placeholder='Weight'
                                    value={state.net_weight_scale}
                                    onChange={handleChange}
                                />
                            </FormControl>
                        </FormGroup>
                    </Grid>
                }

                <Grid item xs={6} md={3}>
                    <FormGroup>
                        <FormLabel>{'Purchase order'}</FormLabel>
                        <FormControl
                            variant='filled'
                            component={Box}
                            width='100%'
                        >
                            <FilledInput
                                autoComplete='off'
                                type='text'
                                name='purchase_order'
                                placeholder='Purchase order'
                                value={state.purchase_order}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </FormGroup>
                </Grid>

                <Grid item xs={6} md={2} xl={1} className={classes.buttonContainer}>
                    <Button
                        variant='contained'
                        color='secondary'
                        style={{ width: '100%' }}
                        onClick={clear}
                    >
                        {'Cancel'}
                    </Button>
                </Grid>
                {
                    (permissions.update_attr) &&
                    <Grid item xs={6} md={2} xl={1} className={classes.buttonContainer}>
                        <Button
                            variant='contained'
                            className={classes.updateBtn}
                            onClick={update}
                        >
                            {'Update'}
                        </Button>
                    </Grid>
                }
            </Grid>
        </Collapse>
    );
}

export default TicketMasterDetailEdit;